var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "eu-basis_5_md" }, [
    _c(
      "div",
      { staticClass: "emd-form-group", attrs: { "data-testid": "order-code" } },
      [
        _c(
          "div",
          { staticClass: "eu-display_flex" },
          [
            _c(
              "label",
              { staticClass: "emd-label", attrs: { "data-testid": "label" } },
              [_vm._v(_vm._s(_vm.$t("orderCode.label")))]
            ),
            _c(
              "emd-tippy",
              {
                staticClass: "eu-ml_1",
                attrs: {
                  id: "orderCode",
                  type: "simple",
                  position: "top",
                  content: _vm.$t("orderCode.tippy"),
                  "data-testid": "tippy",
                },
              },
              [_c("i", { staticClass: "uil uil-info-circle" })]
            ),
          ],
          1
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.orderCode,
              expression: "orderCode",
            },
          ],
          staticClass: "emd-input",
          attrs: { "data-testid": "input" },
          domProps: { value: _vm.orderCode },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.orderCode = $event.target.value
            },
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }